<!-- 配送设置 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <div class="top">
        <div class="top-title flex">
          互斥设置<span class="color">（优惠不同享）</span>
          <!-- 互斥设置<span class="color"
            >【线下消费，在线商城，计次商城】优惠不同享（至少勾选2种）</span
          > -->
        </div>
        <el-checkbox-group v-model="offline_buy" class="flex">
          <el-checkbox label="1">积分</el-checkbox>
          <el-checkbox label="2">优惠券</el-checkbox>
          <el-checkbox label="3">会员折扣</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class=" show" v-if="offline_buy.length > 0">
        <div class=" top-title">
          优先适用顺序
        </div>
        <el-tag v-for="(item, index) in offline_buy" :key="index">
          {{
            index +
              1 +
              " " +
              (item == 1 ? "积分" : item == 2 ? "优惠券" : "会员折扣")
          }}
        </el-tag>
      </div>
      <div class="bottom">
        <div>
          提示: 1.勾选一个，线下消费没有互斥，且不生效;
        </div>
        <div style="text-indent: 30px">
          2.勾选两个互斥生效,都不选则没有互斥。
        </div>
      </div>
      <div class="btn">
        <el-button type="primary" @click="add">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getCouponSetting, setCouponSetting } from "@/api/couponSetting";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "merch_id", "app_id"])
  },
  data() {
    return {
      offline_buy: [] //买单互斥规则 1积分 2优惠券 3会员折扣
    };
  },
  created() {
    this.details();
  },
  methods: {
    add() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      if (this.offline_buy.length != 0) {
        data.offline_buy = this.offline_buy.join(",");
      } else {
        data.offline_buy = "";
      }

      setCouponSetting(data).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    details() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      getCouponSetting(data).then(res => {
        console.log("请求数据", res);
        if (res.data.offline_buy != "") {
          this.offline_buy = res.data.offline_buy.split(",");
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  /* padding: 0 48px 48px 27px; */
  background: #f0f2f5;
  .bodycontent {
    padding: 20px 26px 11px 20px;
    height: 100vh;
    border: 1px solid #f1f1f1;
    overflow: auto;
    min-width: 900px;
    background: rgba(240, 242, 245, 1);
    .top {
      width: 100%;
      height: 118px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      padding: 0 24px;
      .top-title {
        height: 50%;
        border-bottom: 1px dashed #eee;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.75);
        .color {
          font-size: 13px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
        }
      }
      .el-checkbox-group {
        height: 50%;
      }
    }
    .show {
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      padding: 0px 24px 10px 24px;
      .top-title {
        padding: 12px 0;
        font-size: 18px;
      }
      .el-tag {
        margin-right: 10px;
      }
    }
    .bottom {
      margin: 18px 0 20px 0;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      > div {
        line-height: 20px;
      }
    }
    .btn {
      margin-top: 48px;
    }
  }
}
.flex {
  display: flex;
  align-items: center;
}
</style>
